import { Alert, Box } from "@mui/material";
import { AlertCircle, CheckCircle } from "lucide-react";

const SuccessErrorAlert = ({
  successMessage,
  errorMessage,
  onSuccessClose,
  onErrorClose,
}) => {
  return (
    <>
      {(errorMessage || successMessage) && (
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
            width: "85%",
            maxWidth: "500px",
          }}
        >
          {errorMessage && (
            <Alert
              severity="error"
              icon={<AlertCircle size={20} />}
              onClose={onErrorClose}
              sx={{
                width: "100%",
                boxShadow: 3,
                borderRadius: 1,
                py: 2,
              }}
            >
              {errorMessage}
            </Alert>
          )}

          {successMessage && (
            <Alert
              severity="success"
              icon={<CheckCircle size={20} />}
              sx={{
                width: "100%",
                boxShadow: 3,
                borderRadius: 1,
                py: 2,
                animation: "slideIn 0.3s ease-out",
                "@keyframes slideIn": {
                  from: { opacity: 0, transform: "translateY(-20px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
              onClose={onSuccessClose}
            >
              {successMessage}
            </Alert>
          )}
        </Box>
      )}
    </>
  );
};

export default SuccessErrorAlert;
